import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import globalMethods from './global_methods';
import vueScrollBehavior from 'vue-scroll-behavior';
import VuePluralize from 'vue-pluralize';
// import * as Sentry from '@sentry/browser';
// import * as Integrations from '@sentry/integrations';
import { polyfill } from "seamless-scroll-polyfill";
import VCalendar from 'v-calendar';
import i18n from './i18n';
import Emitter from 'component-emitter';
import { defineCustomElements } from '@ionic/pwa-elements/loader';

defineCustomElements(window);

polyfill();

window.appEventBus = new Emitter;

Vue.config.productionTip = false

Vue.mixin({methods: globalMethods});

Vue.use(vueScrollBehavior, { router, delay: 1 });

Vue.use(VuePluralize);

Vue.use(VCalendar);

new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

if (window.cordova && window.cordova.InAppBrowser) {
   window.open = window.cordova.InAppBrowser.open;
}

if (window.cordova) {
  // Sentry.init({
  //   dsn: process.env.SENTRY_DSN,
  //   integrations: [new Integrations.Vue({ Vue })],
  // });
}

if (window.cordova) {
  if (process.env.NODE_ENV == 'production') {
    // window.FirebasePlugin.setAnalyticsCollectionEnabled(true);
  }
} else {
  console.log('Web version detected, all window.FirebasePlugin calls will be faked.');

  class NoopFirebasePlugin {
    getToken() {
      console.log('NoopFirebasePlugin: getToken called');
      return;
    }
    logEvent() {
      console.log('NoopFirebasePlugin: logEvent called');
      return;
    }
    onMessageReceived() {
      console.log('NoopFirebasePlugin: onMessageReceived called');
      return;
    }
    onTokenRefresh() {
      console.log('NoopFirebasePlugin: onTokenRefresh called');
      return;
    }
    setScreenName(screenName) {
      console.log(`NoopFirebasePlugin: setScreenName called: ${screenName}`);
      return;
    }
  }

  window.FirebasePlugin = new NoopFirebasePlugin();
}
